import Splide from "@splidejs/splide";

function initSliderButtonsTabs(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-buttons-tabs").forEach((el) => {
		const splideTabs = new Splide(el, {
			perPage: "auto",
			gap: "clamp(1.0625rem,-.0833333333rem + 3.6666666667vw,3.125rem)",
			pagination: false,
			arrows: false,
			snap: true,
			interval: 6000,
			focus: 0,
			speed: 700,
			omitEnd: true,
			pauseOnHover: true,
			focus: "left",
		});

		splideTabs.mount();

	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderButtonsTabs());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-slider-buttons-tabs", ($block) => {
		initSliderButtonsTabs($block && $block.jquery ? $block.get(0) : $block);
	});
}
